<template>
  <!--客服链接内嵌页面-->
  <tk-container :status="status" style="background: #fff;">
    <my-header slot="header">在线客服</my-header>
    <tk-flex column style="height: 100vh;">
      <iframe style="background: #fff;border-bottom: 1px solid #f5f5f5;" id="contentIFrame" height="90%" class="full-width" name="ContentNew" allowtransparency="yes" scrolling="yes" frameborder="0" onload="this.width === this.contentWindow.document.body.scrollWidth + 5" />
    </tk-flex>
  </tk-container>
</template>

<script>
let iframe
export default {
  data () {
    return {
      status: 'loading',
      watchStatus: false
    }
  },
  computed: {},
  mounted () {
    this.getInit()
  },
  methods: {
    // 省会参数province=${}&城市参数city=${}备注参数note=${}&
    async getInit () {
      try {
        this.setStatusBar('dark')
        iframe = document.getElementById('contentIFrame')
        iframe.src =
          `http://s.appurl.me/s/52534pzps?
          mobile=${this.userInfo.phone}&
          nickName=${this.userInfo.name}&
          source=威选商城平台&avatarUrl=${this.userInfo.avatar}
          `
        iframe.onload = iframe.onreadystatechange = this.iframeload()
      } catch (e) {
        this.status = 'error'
        this.$tkGlobal.toast.add('加载数据失败')
      }
    },
    iframeload () {
      if (!iframe.readyState || iframe.readyState === 'complete') {
        setTimeout(() => {
          this.status = false
          this.watchStatus = true
        }, 800)
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .btnCovered {
    background: rgba(0, 0, 0, 0.3) !important;
    position: absolute;
    width: 30px;
    height: 30px;
    top: 11px;
    right: 10px;
    margin: 0;
  }
</style>
